import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import {determinarPaginaAtualCupons, alterarRegistrosPorPaginaCupons} from '../../actions/cupom/cuponsActions'

export class PaginacaoCupom extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtualCupons}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPaginaCupons}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtualCupons,
    alterarRegistrosPorPaginaCupons
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    cupons: state.cupom.cupons,
    total: state.cupom.total,
    paginaAtual: state.cupom.paginaAtualCupons,
    registrosPorPagina: state.cupom.registrosPorPaginaCupons
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoCupom)
